import { ACCESS_LIST } from "../statics/localStorage";

export const accessCheck = (accessId) => {
    let arr = (ACCESS_LIST())
    let result = arr.find((item) => item?.functionName == accessId);
    return result?._id ? true : false;
}